export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.ecc0164d.worker.js");
}
